import { Controller } from "@hotwired/stimulus"

// Separate the slider configuration into its own function for better organization
const getSliderConfig = (element) => ({
  items: 1,
  slideBy: 'page',
  autoplay: false,
  controls: true,
  controlsPosition: 'bottom',
  mouseDrag: true,
  navPosition: 'bottom',
  responsive: {
    640: { // sm
      items: element.dataset.sm || 1
    },
    768: { // md
      items: element.dataset.md || 2
    },
    1024: { // lg
      items: element.dataset.lg || 2
    },
    1280: { // xl
      items: element.dataset.xl || 3
    }
  }
});

export default class extends Controller {
  static targets = ['slider'];

  async connect() {
    try {
      // Dynamically import tiny-slider using webpack chunk
      const { tns } = await import(
        'tiny-slider/src/tiny-slider'
      );

      // Initialize slider with configuration
      this.slider = tns({
        container: this.sliderTarget,
        ...getSliderConfig(this.element),
        ...JSON.parse(this.element.dataset.config || '{}')
      });
    } catch (error) {
      console.error('Failed to initialize slider:', error);
    }
  }

  disconnect() {
    if (this.slider) {
      this.slider.destroy();
    }
  }
}
